/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      firstName
      lastName
      email
      avatar
      company
      title
      country
      lastLogin
      createdAt
      updatedAt
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        email
        avatar
        company
        title
        country
        lastLogin
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getSurveyQuestion = /* GraphQL */ `
  query GetSurveyQuestion($id: ID!) {
    getSurveyQuestion(id: $id) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;
export const listSurveyQuestions = /* GraphQL */ `
  query ListSurveyQuestions(
    $filter: ModelSurveyQuestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSurveyQuestions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getEventConfig = /* GraphQL */ `
  query GetEventConfig($id: ID!) {
    getEventConfig(id: $id) {
      id
      stage
      streamStartTime
      useBackupStream
      environment
      createdAt
      updatedAt
    }
  }
`;
export const userByEmail = /* GraphQL */ `
  query UserByEmail(
    $email: String
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        lastName
        email
        avatar
        company
        title
        country
        lastLogin
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
